import { LeadsFunnelsPage, LeadsFunnelsHeader } from './ui';

export const LeadsFunnels = {
  Page: LeadsFunnelsPage,
  Header: LeadsFunnelsHeader,
};
